"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../../types");
function checkIsMarketActive(marketStatus) {
    return marketStatus === types_1.GQL.MarketStatus.ACTIVE;
}
exports.default = checkIsMarketActive;
//# sourceMappingURL=checkIsMarketActive.js.map